import React from "react";
import {
  Container,
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Link as MuiLink,
} from "@mui/material";
import { OpenInNew, Public } from "@mui/icons-material";

export const CreditsPage: React.FC = () => {
  const sources = [
    {
      name: "Fair Work Ombudsman",
      url: "https://www.fairwork.gov.au/employment-conditions/public-holidays",
      description: "Federal public holiday information covering all states",
    },
    {
      name: "Western Australia Government",
      url: "https://www.wa.gov.au/service/employment/workplace-arrangements/public-holidays-western-australia",
      description: "Western Australian public holidays",
    },
    {
      name: "Victoria Government",
      url: "https://business.vic.gov.au/business-information/public-holidays/victorian-public-holidays-2026",
      description: "Victorian public holidays",
    },
    {
      name: "SafeWork Tasmania",
      url: "https://worksafe.tas.gov.au/topics/laws-and-compliance/public-holidays",
      description: "Tasmanian public holidays",
    },
    {
      name: "ACT Chief Minister, Treasury and Economic Development Directorate",
      url: "https://www.act.gov.au/living-in-the-act/public-holidays-school-terms-and-daylight-saving",
      description: "Australian Capital Territory public holidays",
    },
    {
      name: "NSW Government",
      url: "https://www.nsw.gov.au/about-nsw/public-holidays",
      description: "New South Wales public holidays",
    },
    {
      name: "NT Government",
      url: "https://nt.gov.au/nt-public-holidays",
      description: "Northern Territory public holidays",
    },
    {
      name: "Queensland Government",
      url: "https://www.qld.gov.au/recreation/travel/holidays/public",
      description: "Queensland public holidays",
    },
    {
      name: "SafeWork SA",
      url: "https://www.safework.sa.gov.au/resources/public-holidays",
      description: "South Australian public holidays",
    },
  ];

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default", py: 4 }}>
      <Container maxWidth="md">
        {/* Header */}
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 2,
            }}
          >
            <Public sx={{ fontSize: 40, color: "primary.main" }} />
            <Typography variant="h3" sx={{ fontWeight: 700, color: "text.primary" }}>
              Credits
            </Typography>
          </Box>
          <Typography variant="h6" color="text.secondary">
            These are the official sources used in the data published on this site
          </Typography>
        </Box>

        {/* Sources */}
        <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 2 }}>
          <List>
            {sources.map((source, index) => (
              <ListItem
                key={index}
                sx={{
                  flexDirection: "column",
                  alignItems: "flex-start",
                  py: 3,
                  px: 2,
                  mb: index < sources.length - 1 ? 2 : 0,
                  borderRadius: 1,
                  bgcolor: "action.hover",
                  borderBottom: 0,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                  <MuiLink
                    href={source.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      fontWeight: 600,
                      fontSize: "1.2rem",
                      textDecoration: "none",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {source.name}
                    <OpenInNew sx={{ fontSize: 18 }} />
                  </MuiLink>
                </Box>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 0.5 }}>
                  {source.description}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.disabled"
                  sx={{ fontFamily: "monospace", fontSize: "0.85rem" }}
                >
                  {source.url}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Paper>
      </Container>
    </Box>
  );
};
